import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import {
  Field,
  formValueSelector,
  propTypes as formPropTypes,
} from 'redux-form'
import { lpForm } from 'lp-form'
import { ComboBox } from 'components'
import * as Types from 'types'
import { SubmitButton, ButtonArea } from 'lp-components'
import { withProps } from 'recompose'
import { selectors } from '../reducer'
import * as apiActions from 'api-actions'
import { formatObjectsToIds, parseIdsToObjects, serializeOptions } from 'utils'

const propTypes = {
  ...formPropTypes,
  schoolOptions: PropTypes.arrayOf(Types.searchSuggestion),
}

function SchoolPartnershipForm({ handleSubmit, submitting, schoolOptions }) {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="schools"
        label="Enter a School Name"
        component={ComboBox}
        options={serializeOptions(schoolOptions, {
          key: 'name',
          value: 'id',
        })}
        isMulti={true}
        format={formatObjectsToIds('id')}
        parse={parseIdsToObjects('id')}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        blurInputOnSelect={false}
      />
      <ButtonArea>
        <SubmitButton {...{ submitting, style: 'secondary' }}>
          Add Partner
        </SubmitButton>
      </ButtonArea>
    </form>
  )
}

SchoolPartnershipForm.propTypes = propTypes

const selectFormValue = formValueSelector('partner-add-partnership')

function mapStateToProps(state) {
  return {
    organizationId: selectFormValue(state, 'organizationId'),
    selectedPartner: selectors.partner(state),
  }
}

const mapDispatchToProps = {
  fetchPartner: apiActions.fetchPartner,
}

export default compose(
  withProps(({ schoolOptions }) => {
    return {
      beforeSubmit: ({ schools, ...values }) => {
        const fullSchools = schools.map((school) => {
          const fullSchool = schoolOptions?.find(
            (school) => school.id === school.id
          )
          return {
            id: school.id,
            name: fullSchool.name,
          }
        })

        return {
          ...values,
          schools: fullSchools,
        }
      },
    }
  }),
  lpForm({
    name: 'school-add-partnership',
    constraints: {
      schoolId: {
        presence: { message: '^School selection cannot be blank' },
      },
    },
  }),
  connect(mapStateToProps, mapDispatchToProps)
)(SchoolPartnershipForm)
